import { Stack } from "@mui/material";
import React, { Fragment, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import FormTextArea from "../../../../components/form/FormTextArea";
import { Controller, useFormContext } from "react-hook-form";
import Span from "../../../../components/display/Span";
import { STATUSES } from "../../../../enums/AppointmentStatus";
//TODO: rename this to something more appropriate, this comopnent is used when rejecting or accepting an appointment
// Template is a reserved name for an entity in our application
export default function PendingConfirmationTemplate({ status }) {
  const { t } = useTranslation();
  const { control, register } = useFormContext();

  const ForwardedFormTextArea = forwardRef((props, ref) => {
    return <FormTextArea {...props} ref={ref} />;
  });

  const title =
    status == STATUSES.ACTIVE
      ? t("AppointmentConfirmationTitle")
      : t("AppointmentRejectionTitle");

  return (
    <Fragment>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        m={1}
      >
        <Span text={title} textAlign={"center"} />
      </Stack>
      <Stack spacing={1}>
        {status == STATUSES.INACTIVE ? (
          <Stack spacing={1}>
            <Controller
              control={control}
              name="statusMessage"
              render={({ field }) => {
                return (
                  <ForwardedFormTextArea
                    {...field}
                    register={register}
                    minRows={10}
                    maxLength={5000}
                    style={{ width: "100%", marginTop: "0.5vw" }}
                    testId={"appointment.pending-confirm.status-message-input"}
                  />
                );
              }}
            />
          </Stack>
        ) : null}
      </Stack>
    </Fragment>
  );
}
